import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareSubmodule = (state, action) => {
  switch (action.type) {
    case SOFTWARE.SUBMODULE_DATA.INITIATE:
      return { isFetching: true, data: action.payload };
    case SOFTWARE.SUBMODULE_DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.SUBMODULE_DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareSubmodule;
